import { render, staticRenderFns } from "./form-data-view.vue?vue&type=template&id=2df8e3f9&scoped=true"
import script from "./form-data-view.vue?vue&type=script&lang=js"
export * from "./form-data-view.vue?vue&type=script&lang=js"
import style0 from "./form-data-view.vue?vue&type=style&index=0&id=2df8e3f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df8e3f9",
  null
  
)

export default component.exports